import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const hash = location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) {
        navigate("/", { replace: true });
        return;
      }
      const session_id = decodeURIComponent(m[1]);
      try {
        const { user } = await exchangeSession(session_id);
        setUser(user);
        // Clean hash
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user } });
      } catch {
        toast.error("No se pudo iniciar sesión, intentá de nuevo");
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-black">
      <div className="flex items-center gap-3 text-neutral-300">
        <Loader2 className="w-5 h-5 animate-spin text-[#ff4500]" />
        Iniciando sesión...
      </div>
    </div>
  );
}
